export default __webpack_public_path__ + "static/media/DaysCount.b0022a86.svg";